// @theme component
export const STEPS_NAME = {
    DRAWER: 'DRAWER',
    INITIAL: 'INITIAL',
    CODE: 'CODE',
    CHANGE_NUMBER: 'CHANGE_NUMBER',
    SUCCESS: 'SUCCESS',
    UNAVAILABLE: 'UNAVAILABLE'
};

export const VERIFICATION_TYPES = {
    DEFAULT: 'default',
    INCENT: 'incent'
};

export const ERROR_INTERVAL_REACHED = 0;
export const ERROR_SERVICE_UNAVAILABLE = 105;
export const ERROR_SERIVCE_LIMITS_REACHED = 178;

export const PHONE_PREFIX = '+52';
export const PASSCODE_LENGTH = 6;
